import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ViewTableComponent } from '../../base/view-table/view-table.component';

@Component({
  selector: 'app-inquiries',
  templateUrl: './inquiries.component.html',
  styleUrls: ['./inquiries.component.css']
})
export class InquiriesComponent extends ViewTableComponent implements OnInit {

  currentPage: number;

  override displayedColumns: string[] = [
    'inquiry_taker_first_name',
    'student_account_title',
    'interests',
    'contact_date',
    'field_booked_on_value',
    'field_showed_value',
    'outcome',
    'phone',
    'email',
  ];

  override getData(params: { parameter: string; value: string; }[]) {
    this.ShowProgressBar = true;
    this.queryParams = params;

    // Add sorting paramaters, if available.
    if (this.sortParams !== undefined) {
      this.queryParams.push(this.sortParams)
    }

    params = [
      ...params,
    ];

    // Load the new data with the filtering parameters.
    let endpoint: string = "/api/v1/reports/inquiries";

    this._drupalRESTService.httpGET(endpoint, params)
      .subscribe((data) => {
        // ShowProgressBar
        this.ShowProgressBar = false;

        this.dataSource = new MatTableDataSource(data['results']);

        // // Pagination
        if (data['results']) {
          this.setupPagination(data, params);
        }
      },
        error => this.handleError(error)
      )
  }

  override setupPagination(data: any, params: { parameter: string; value: string; }[]) {
    const pageParam = params.find(param => param.parameter === 'page');
    if (this.paginator) {
      this.paginator.length = data?.['count'] ?? 0;
      this.paginator.pageSize = this.pageSize;
      this.paginator.pageIndex = pageParam ? parseInt(pageParam.value, 10) : 0;
    }
    // DO NOT call updateRouterParams here - prevents duplicate requests
  }
}
